import { LogLevel } from "@azure/msal-browser";

export const usePKCE = window.injectPKCE === true;

export const isDevTenant = ["dev", "test", 'staging', "qa"].includes(window.env.APP_ENV.toLowerCase());

export const msalConfig = {
    auth: {
        clientId: isDevTenant ? "d0952a15-c248-42cb-a3d5-31a104e6fe94" :
            "370fbf66-8bed-4f65-8938-9d97d9ff8e07",
        authority: usePKCE ?
            (isDevTenant ? 'https://login.microsoftonline.com/c6e1cd41-a0c6-4bda-b507-226a66405f0b' :
                'https://login.microsoftonline.com/2d40ff2a-ce93-44bc-9f2c-bf24a902316d')
            : "https://login.microsoftonline.com/house.virginia.gov",
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

export const loginRequest = {
    scopes: ["User.Read"]
};

export const logoutRequest = {
    scopes: ["User.Read"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

export const houseDomains = [
    "house.virginia.gov"
];

export const senateDomains = [
    "senate.virginia.gov"
];

export const legislativeDomains = [
    "dlas.virginia.gov",
    "dls.virginia.gov",
    "sfac.virginia.gov",
    "hac.virginia.gov",
    "vcoy.virginia.gov",
    "jchc.virginia.gov",
    "vscc.virginia.gov",
    "dcp.virginia.gov",
    "vcf.virginia.gov",
    "jlarc.virginia.gov",
    "ceur.virginia.gov",
    "jcots.virginia.gov",
    "bhc.virginia.gov",
    "vhc.virginia.gov",
    "va250.virginia.gov",
    "chesbay.us",
    "cubc.virginia.gov",
    "virginiacapitol.gov"
];
